import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { EmailButtonComponent } from '../email-button/email-button.component';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  selector: 'email-message-header',
  styleUrls: ['./email-message-header.component.less'],
  template: `
    <div class="message-header web-message-header">
      <table class="message-header-table" cellspacing="0" cellpadding="0">
        <tr>
          <td class="message-header-content">
            <table>
              <tr>
                <td width="100%">
                  <email-text
                    *mailgunIf="header"
                    [contents]="header"
                    presetName="header"
                    size="large"
                  />
                  @if (subheader) {
                    <email-text
                      *mailgunIf="subheader"
                      [contents]="subheader"
                      presetName="paragraph"
                      [className]="subheaderClassName"
                    />
                  }
                </td>
                <td width="0" [class.align-top]="avatarAlignTop">
                  <ng-content select="[image]" />
                  @if (imageUrl) {
                    <img
                      *mailgunIf="imageUrl"
                      class="avatar"
                      width="48"
                      height="48"
                      [attr.src]="imageUrl.toJSON()"
                      [attr.alt]="imageAlt?.toJSON()"
                    />
                  }

                  @if (buttonUrl) {
                    <email-button
                      *mailgunIf="buttonUrl"
                      [href]="buttonUrl"
                      [label]="buttonText || buttonUrl"
                    />
                  }
                </td>
              </tr>
              @if (separator) {
                <tr>
                  <td colspan="3" height="28">&nbsp;</td>
                </tr>
                <tr>
                  <td colspan="3">
                    <hr />
                  </td>
                </tr>
                <tr>
                  <td colspan="3" height="28">&nbsp;</td>
                </tr>
              }
            </table>
          </td>
        </tr>
      </table>
    </div>
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [
    EmailTextComponent,
    EmailButtonComponent,
    EmailMailgunIfDirective,
    EmailMailgunIfDirective,
    EmailMailgunIfDirective,
    EmailMailgunIfDirective,
  ],
})
export class EmailMessageHeaderComponent {
  @Input() public header: WrappedValue<string>;
  @Input() public subheader?: WrappedValue<string>;
  @Input() public imageUrl?: WrappedValue<string>;
  @Input() public imageAlt?: WrappedValue<string>;
  @Input() public buttonText?: WrappedValue<string>;
  @Input() public buttonUrl?: WrappedValue<string>;
  @Input() public separator: boolean = true;
  @Input() public avatarAlignTop: boolean;
  @Input() public subheaderClassName?: string;
}
